class column1 {
	constructor() {
		this.hideStartPosition();
	}

	hideStartPosition() {
		if ($('.start-position').length) {
			if ($('.start-position')[0].childElementCount <= 0) {
				$('.start-position').remove();
			}
		}
	}
}

export default new column1();